export default class CheckPriceParams {
  constructor(props) {
    this.props = props;
    return this;
  }

  getDepartureBusStop() {
    return this.getBusStop(this.props.departureAddress);
  }

  getReturnBusStop() {
    if(this.props.returnAddress){
      return this.getBusStop(this.props.returnAddress);
    } else {
      return null;
    }
  }

  getBusStop(addressObject) {
    if (addressObject === null || addressObject.selectedObject === null) {
      return null;
    }

    if (addressObject.selectedObject.g) {
      //is google address
      return null;
    } else {
      return addressObject.selectedObject.value;
    }
  }

  getReturnToDifferentPlaces() {
    return this.props.returnFlight && this.props.differentReturnAddress;
  }

  params() {
    return {
      adult: this.props.adultsNumber,
      children: this.props.childrenNumber,
      departurePostcode: this.props.departureAddress.postcode,
      departureBusStop: this.getDepartureBusStop(),
      returnPostcode: this.props.returnAddress ? this.props.returnAddress.postcode : null,
      returnBusStop: this.getReturnBusStop(),
      returnToDifferentPlace: this.getReturnToDifferentPlaces(),
      returnFlight: this.props.returnFlight ? this.props.returnFlight.id : null,
      departureFlight: this.props.departureFlight ? this.props.departureFlight.id : null,
    };
  }
}
